/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ApiRunStorageState = {
  STORAGESTATE_AVAILABLE: 'STORAGESTATE_AVAILABLE',
  STORAGESTATE_ARCHIVED: 'STORAGESTATE_ARCHIVED',
} as const;
export type ApiRunStorageState = (typeof ApiRunStorageState)[keyof typeof ApiRunStorageState];

export function instanceOfApiRunStorageState(value: any): boolean {
  for (const key in ApiRunStorageState) {
    if (Object.prototype.hasOwnProperty.call(ApiRunStorageState, key)) {
      if (ApiRunStorageState[key as keyof typeof ApiRunStorageState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ApiRunStorageStateFromJSON(json: any): ApiRunStorageState {
  return ApiRunStorageStateFromJSONTyped(json, false);
}

export function ApiRunStorageStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiRunStorageState {
  return json as ApiRunStorageState;
}

export function ApiRunStorageStateToJSON(value?: ApiRunStorageState | null): any {
  return value as any;
}

export function ApiRunStorageStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ApiRunStorageState {
  return value as ApiRunStorageState;
}
